import BigNumber from 'bignumber.js';

export const formatAmount = (value: number | string) =>
  new BigNumber(value).toFormat(2, {
    decimalSeparator: '.',
    groupSeparator: ',',
    groupSize: 3,
  });
